<template>
  <PeriodPicker
    frequencyLabel="Pay Frequency"
    periodLabel="Period"
    :frequencyId="payFrequencyId"
    :dateBegin="dateBegin"
    :dateEnd="dateEnd"
    :deriveCurrentPeriodOnMount="true"
    @frequencyChange="frequencyChangeHandler"
    @periodChange="periodChangeHandler"
  />
</template>

<script>
import { PeriodPicker } from '@/components/shared/datePickers'
import { mapFields } from '@/vueHelpers/vuex'

export default {
  components: {
    PeriodPicker
  },
  computed: {
    ...mapFields('payrollReportFilters', ['payFrequencyId', 'dateBegin', 'dateEnd'])
  },
  methods: {
    frequencyChangeHandler (newValue) {
      this.dateBegin = null
      this.dateEnd = null
      this.payFrequencyId = newValue
      this.$emit('frequency-change', newValue)
    },
    periodChangeHandler (dateBegin, dateEnd) {
      this.dateBegin = dateBegin
      this.dateEnd = dateEnd
      this.$emit('search')
    }
  }
}
</script>
